/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Object } from '../../models/object';
import { PaginatedProjectOwnersResponseDto } from '../../models/paginated-project-owners-response-dto';

export interface AdminProjectOwnersControllerGetAllProjectOwners$Params {

/**
 * Page number (1-indexed)
 */
  page?: number;

/**
 * Number of items per page
 */
  limit?: number;

/**
 * Search term (searches in username, email, fullName, company)
 */
  search?: string;

/**
 * Field to sort by
 */
  sortBy?: Object;

/**
 * Sort order (ascending or descending)
 */
  sortOrder?: Object;

/**
 * Filter by banned status
 */
  isBanned?: boolean;
}

export function adminProjectOwnersControllerGetAllProjectOwners(http: HttpClient, rootUrl: string, params?: AdminProjectOwnersControllerGetAllProjectOwners$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedProjectOwnersResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectOwnersControllerGetAllProjectOwners.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('isBanned', params.isBanned, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedProjectOwnersResponseDto>;
    })
  );
}

adminProjectOwnersControllerGetAllProjectOwners.PATH = '/admin/project-owners';
